<img 
src="{{combatant.src}}" 
alt="{{combatant.name}}"/>
